/** 调用页面 */
import React from 'react';
import {message, Table} from 'antd';
import api from "../../../lib/api";

class ComTable extends React.Component{
  isPageSizeChange = false;
  state = {
    scrollY: 560,
    page: 1,
    pageSize: 30,
    tbData: [],
    orders: {},
    loading: false,
    pagination: {
      current: 1,
      pageSize: 30,
      defaultPageSize: 30,
      pageSizeOptions: [30, 50, 100],
      total: 0,
      showSizeChanger: true,
      showQuickJumper: true,
      onShowSizeChange: (current, size) => this.pageSizeChange(current, size),
      showTotal: total => `共 ${total} 条数据`,
    }
  };
  columns = [
    {
      title: '调用页面',
      dataIndex: 'path'
    }, {
      title: '调用占比',
      dataIndex: 'requestRatio',
      sorter: true,
      showSorterTooltip: false
    }, {
      title: '平均响应时间',
      dataIndex: 'avgPageLoadTime',
      sorter: true,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.avgPageLoadTime} ms</span>
      )
    }, {
      title: '调用量',
      dataIndex: 'requestCount',
      sorter: true,
      showSorterTooltip: false
    }, {
      title: '调用频率/min',
      dataIndex: 'requestRate',
      sorter: true,
      showSorterTooltip: false
    },
  ];
  UNSAFE_componentWillMount() {
    this.ajaxTransferData();
    this.setState({
      scrollY: document.documentElement.clientHeight - 360
    });
    window.onresize= () => {
      this.setState({
        scrollY: document.documentElement.clientHeight - 360
      })
    }
  };
  // 表格数据
  ajaxTransferData() {
    this.setState({loading: true});
    const {page, pageSize, orders} = this.state;
    const {startTime, endTime, resourcePath, methodType} = this.props.filterData;
    const params = {
      startTime,
      endTime,
      resourcePath,
      methodType,
      page,
      pageSize,
      sortFile: orders.field || null,
      orderBy: orders.direct || null
    };
    api.ajaxTransferData(params).then(res => {
      this.setState({loading: false});
      if (res.success && res.status === 200) {
        this.setState({
          tbData: res.data || [],
          pagination: Object.assign(this.state.pagination, {
            pageSize: res.size,
            current: res.page,
            total: res.total
          })
        })
      } else {
        message.error(res.message);
      }
    })
  };
  // pageSize 改变
  pageSizeChange = (current, size) => {
    this.isPageSizeChange = true;
    this.setState({
      page: 1,
      pageSize: size
    }, () => {
      this.ajaxTransferData();
    });
  };
  // 页数 排序 改变
  pageChange = (pagination, filters, sorter, extra) => {
    if (this.isPageSizeChange) {
      this.isPageSizeChange = false;
      return
    }
    let page = extra.action === 'sort' ? 1 : pagination.current;
    let orders = {};
    if (sorter.order) {
      orders = {
        field: sorter.field,
        direct: sorter.order === "ascend" ? "asc" : "desc"
      }
    }
    this.setState({
      orders,
      page,
      pagination: Object.assign(this.state.pagination, {current: page, pageSize: pagination.pageSize}),
      pageSize: pagination.pageSize
    }, () => {
      this.ajaxTransferData();
    });
  };
  render() {
    const { tbData, pagination, loading, scrollY } = this.state;
    return (
      <div className='card'>
        <Table scroll={{x: 800, y: scrollY}} rowKey={(record, index) => index} bordered loading={loading} pagination={pagination}
               columns={this.columns} dataSource={tbData} onChange={this.pageChange} />
      </div>
    );
  }
};
export default ComTable;
